import { Directive, HostListener, ElementRef, Input, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[trim]',
})
export class TrimDirective {
  private el: HTMLInputElement;
  @Input() ngModel;
  @Output() ngModelChange = new EventEmitter();

  constructor(
    private elementRef: ElementRef) {
    this.el = this.elementRef.nativeElement;
  }

  @HostListener('blur', ['$event.target.value'])
  onBlur(value) {
    this.el.value = value.replace(/\s\s+/g, ' ');
    this.ngModelChange.emit(value.trim());
  }

  @HostListener('keyup', ['$event.target.value'])
  inputChanged(value) {
    this.el.value = value.replace(/\s\s+/g, ' ');
  }

}
